import { Icon } from "@mdotm/shadcn/legacy/components";
import { NumberInput, type NumberInputProps } from "@mdotm/shadcn/mdotm/components";

export type PercentageInputProps = NumberInputProps;

export function PercentageInput(props: PercentageInputProps): React.JSX.Element {
	return (
		<NumberInput placeholder="0" rightContent={<Icon icon="Percentile" />} min={0} max={100} step={0.01} {...props} />
	);
}
